
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class InfoIcon extends Vue {
    @Prop({default: ''}) tooltip: string;
    @Prop({default: ''}) btnClass: string;
    @Prop({default: 'primary'}) color: string;
    @Prop({default: 'mdi-help-circle'}) icon: string;

}
